/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselAdvancedIntegrity
 */
export interface VesselAdvancedIntegrity {
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    inspections?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    ismDeficienciesDuringInspections?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    bans?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    flagPerformanceParis?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    flagPerformanceTokyo?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedIntegrity
     */
    sanctions?: any | null;
}

/**
 * Check if a given object implements the VesselAdvancedIntegrity interface.
 */
export function instanceOfVesselAdvancedIntegrity(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselAdvancedIntegrityFromJSON(json: any): VesselAdvancedIntegrity {
    return VesselAdvancedIntegrityFromJSONTyped(json, false);
}

export function VesselAdvancedIntegrityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselAdvancedIntegrity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inspections': !exists(json, 'inspections') ? undefined : json['inspections'],
        'ismDeficienciesDuringInspections': !exists(json, 'ism_deficiencies_during_inspections') ? undefined : json['ism_deficiencies_during_inspections'],
        'bans': !exists(json, 'bans') ? undefined : json['bans'],
        'flagPerformanceParis': !exists(json, 'flag_performance_paris') ? undefined : json['flag_performance_paris'],
        'flagPerformanceTokyo': !exists(json, 'flag_performance_tokyo') ? undefined : json['flag_performance_tokyo'],
        'sanctions': !exists(json, 'sanctions') ? undefined : json['sanctions'],
    };
}

export function VesselAdvancedIntegrityToJSON(value?: VesselAdvancedIntegrity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inspections': value.inspections,
        'ism_deficiencies_during_inspections': value.ismDeficienciesDuringInspections,
        'bans': value.bans,
        'flag_performance_paris': value.flagPerformanceParis,
        'flag_performance_tokyo': value.flagPerformanceTokyo,
        'sanctions': value.sanctions,
    };
}

